<div style="display: block;">
    <div class="characterCount" id="characterCount">
        {{charactersRemainingText}}
    </div>
    <textarea class='box' id="modelDescription" [(ngModel)]="description" 
        (ngModelChange)="updateDescription()" placeholder="Descripe your model" rows="3" cols="50">
    </textarea>
</div>
